import { Injectable } from '@angular/core';
import { ApiClientService } from '../../core/services/api-client.service';
import { NExpeConfig } from './nexpe.model';

@Injectable({
  providedIn: 'root',
})
export class NExpeConfigService extends ApiClientService {
  /**
   * Retrieves all NExpe configurations or multiple by query
   * GET /config/nexpe?nexpes=N1,N2,N3
   */
  getAllNExpeConfigs(nexpes?: string[]) {
    const path =
      nexpes && nexpes.length > 0 ? `/config/nexpe?nexpes=${nexpes.join(',')}` : '/config/nexpe';
    return this.get<NExpeConfig[]>(path);
  }

  /**
   * Updates the configuration of a NExpe
   * PUT /config/nexpe
   */
  updateNExpeConfig(config: NExpeConfig[]) {
    return this.put<NExpeConfig[]>('/config/nexpe', config);
  }

  /**
   * Deletes a NExpe configuration
   * DELETE /config/nexpe/:nexpe
   */
  deleteNExpeConfig(nexpe: string) {
    console.log('Deleting NExpe config for:', nexpe);
    return this.delete(`/config/nexpe/${nexpe}`);
  }
}
